import Login from "../components/Login/Login";
import Layout from "../Layout/Layout";

const LoginPage = () => {
  return (
    <Layout>
      <Login />
    </Layout>
  );
};

export default LoginPage;
